import { assessmentStateMap } from './utils/assessmentStateUtil';
import { isConstantZeroToneHeard } from './utils/constantZeroUtil';
import { isValidInput, checkUpdateResult } from './utils/helperUtil';
/**
 * List of supported device model ids
 * @constant
 * @default default ['6144007', '540938247', '72780372515670', '72986808818502']
 */
export var deviceModelIds = ['6144007', '540938247', '72780372515670', '72986808818502'];
/**
 * Gets the hearing profile file for a specific device model id
 *
 * @param deviceModelId Input model id for the hearing device
 * @returns Returns the hearing profile file for the device
 */
export function getHearingProfileFile(deviceModelId) {
    if (!deviceModelIds.includes(deviceModelId)) {
        console.error("\nError: The Hearing Profile Check file for device ".concat(deviceModelId, " is not available."));
        return null;
    }
    try {
        return require("./OTC_Tool_HLAAPreprocessor_Output/".concat(deviceModelId, "_HearingProfile_File.json"));
    }
    catch (error) {
        console.error("Module not found: ".concat(error.message));
        return null;
    }
}
/**
 * Gets the next state in hlaa
 *
 * @param deviceModelId Input model id for the hearing device
 * @param frequency Current frequency being tested in hlaa
 * @param toneSequence Current tone sequence in hlaa
 * @param isFirstRun True if first run of hlaa
 * @returns Returns the next state for the device
 */
export function getNextState(deviceModelId, frequency, toneSequence, isFirstRun) {
    var hearingProfileFile = getHearingProfileFile(deviceModelId);
    if (!(hearingProfileFile === null || hearingProfileFile === void 0 ? void 0 : hearingProfileFile.StateNodes) || !isValidInput(hearingProfileFile.StateNodes, frequency, toneSequence))
        return null;
    if (isConstantZeroToneHeard(hearingProfileFile.StateNodes, deviceModelId, frequency, toneSequence, isFirstRun)) {
        return { workflow: assessmentStateMap[5] };
    }
    var count = 0;
    var state = hearingProfileFile.StateNodes["".concat(frequency)];
    var result;
    for (var _i = 0, toneSequence_1 = toneSequence; _i < toneSequence_1.length; _i++) {
        var tone = toneSequence_1[_i];
        state = state["ToneHeardNext".concat(tone)];
        count++;
        if (state === null)
            break;
        var updatedResult = checkUpdateResult(state, count, toneSequence);
        if (updatedResult) {
            result = updatedResult;
            break;
        }
    }
    return result !== null && result !== void 0 ? result : null;
}
/**
 * Gets the configured frequencies for a specific device model id
 *
 * @param deviceModelId Input model id for the hearing device
 * @returns Returns the configured frequencies for the device
 */
export function getConfiguredFrequencies(deviceModelId) {
    var hearingProfileFile = getHearingProfileFile(deviceModelId);
    if (!hearingProfileFile)
        return null;
    var frequencies = hearingProfileFile.FrequencyIndexMap;
    return frequencies;
}
/**
 * Gets the HA configuration for a specific device model id
 *
 * @param deviceModelId Input model id for the hearing device
 * @returns Returns the HA configuration for the device
 */
export function getHAConfiguration(deviceModelId) {
    var hearingProfileFile = getHearingProfileFile(deviceModelId);
    if (!hearingProfileFile)
        return null;
    var configuration = hearingProfileFile.HAConfiguration;
    return configuration;
}
export default {
    getConfiguredFrequencies: getConfiguredFrequencies,
    getHearingProfileFile: getHearingProfileFile,
    getNextState: getNextState,
    getHAConfiguration: getHAConfiguration,
};
